<div class="col-12">
	<list-table [columns]="tableColumns" [manager]="dataTableManager" [actions]="tableActions">
	</list-table>	
</div>